
'use strict'

class Validator {
    
    constructor(){
        this.errors = [];
        this.inputs = [];
    }

    add (name, validators) {
        this.inputs[name] = validators;
        return this;
    }

    validate () {
        this.errors = [];
        Object.keys(this.inputs).forEach((name, i) => {
            let val = '';
            let iname = name;
            if(document.getElementById(name)){
                val = document.getElementById(name).value;
                iname = document.getElementById(name).getAttribute('data-validator-name');
            }
            if(!this.inputs[name]){
                return;
            }
            this.inputs[name].forEach(v => {
                if(!v.validate(val)){
                    if(!this.errors[i]){
                        this.errors[i] = [name, []];
                    }
                    let err = v.getError().replace('{name}', iname);
                    this.errors[i][1].push(err);
                }
            });    
        });
        this.errors = this.errors.filter(function (item) {
            return item !== undefined;
        });
        if(this.errors.length > 0){
            return false;
        }
        return true;
    }

    getErrors () {
        return this.errors;
    }

}

export default Validator;
